<script setup>

import {computed, ref, watch} from "vue";

const props = defineProps({
  value: String,
  name: String,
  width: {
    type: Number,
    default: 640,
  },
  height: {
    type: Number,
    default: 640,
  },
  crop: {
    type: Boolean,
    default: false,
  },
  subtitle: String,
})

const value = ref(props.value);

const dataUriFromFormField = (field) => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.addEventListener('load', () => {
      resolve(reader.result);
    });

    reader.readAsDataURL(field);
  });
}

const resizeImage = (imgEl, wantedWidth, wantedHeight, crop) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const widthRatio = wantedWidth / imgEl.width;
  const heightRatio = wantedHeight / imgEl.height;


  if(crop){

    const ratio = Math.max(widthRatio, heightRatio);

    canvas.width  = wantedWidth;
    canvas.height = wantedHeight;

    const resizedImgWidth = imgEl.width * ratio;
    const resizedImgHeight = imgEl.height * ratio;

    // console.log({
    //   width: wantedWidth,
    //   height: wantedHeight,
    //   ratio,
    //   imgWidth: imgEl.width,
    //   imgHeight: imgEl.height,
    //   resizedImgWidth,
    //   resizedImgHeight,
    // })
    ctx.drawImage(
      imgEl,

      0,
      0,
      imgEl.width,
      imgEl.height,

      ((wantedWidth - (resizedImgWidth)) / 2),
      ((wantedHeight - (resizedImgHeight)) / 2),
      resizedImgWidth,
      resizedImgHeight
    );
  }else{

    const ratio = (widthRatio + heightRatio) / 2;

    canvas.width = imgEl.width * ratio;
    canvas.height = imgEl.height * ratio;

    ctx.drawImage(imgEl,
      0,
      0,
      canvas.width,
      canvas.height
    );
  }

  return canvas.toDataURL('image/jpeg', 95);
}

const resizeImageFromDataUri = (dataUri, toWidth, toHeight, crop) => {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.addEventListener('load', () => {
      const resizedDataUri = resizeImage(img, toWidth, toHeight, crop);
      resolve(resizedDataUri);
    });
    img.src = dataUri;
  });

}

const input = ref(null);

const changePhoto = async (evt) => {

  evt.preventDefault();
  evt.stopPropagation();

  const file = input.value.files[0];

  if(!file){
    this.value = null;
    return;
  }

  const dataUri = await dataUriFromFormField(file);

  value.value = {
    image: await resizeImageFromDataUri(dataUri, props.width, props.height, !!props.crop),
    name: file.name,
  };

  return false;

};
const imageUrl = computed(() => {
  if(typeof value.value == 'string'){
    return value.value;
  }
  return value.value?.image;
});

watch(value, () => {
  if(!value.value){
    input.value.value = null;
  }
});

</script>

<template>
  <div class="image-input">
    <label :for="name">
      Upload foto
    </label>

    <div v-if="imageUrl" class="image-preview">
      <div class="image-preview__datawrapper">
        <div class="image-preview__img">
          <img :src="imageUrl"/>
        </div>
        <div class="image-preview__data">
          <span class="image-name">{{ value ?. name }}</span>
          <span class="image-size"></span>
        </div>
      </div>
      <div class="image-preview__close">
        <button type="button" @click="value = null" class="image-preview__delete"><svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><path d="M1 10 11 0M1 0l10 10" stroke="#374151" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      </div>
    </div>

    <input
      ref="input"
      type="file"
      accept="image/*"
      @change="evt => changePhoto(evt)"
      :id="name"
      :name="name"
      hidden
    />


  </div>
</template>

<style scoped>
  .image-preview__img img {
    max-width: 100%;
  }
</style>